// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.CustomerOfferItemQuantity')
class Orders__CustomerOfferItemQuantity {
    @jsonProperty(() => Orders__CustomerOfferItemQuantity.Id)
    id: Orders__CustomerOfferItemQuantity.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "quantity", "margin", "unitPrice", "deliveryTimeWeeks", "bestVendorOfferQuantity", "bestVendorOfferQuantityId", "offerItem", "offerItemId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "quantity", "margin", "unitPrice", "deliveryTimeWeeks", "bestVendorOfferQuantity", "bestVendorOfferQuantityId", "offerItem", "offerItemId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "quantity", "margin", "unitPrice", "deliveryTimeWeeks", "bestVendorOfferQuantity", "bestVendorOfferQuantityId", "offerItem", "offerItemId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "quantity": "number", "margin": "number", "unitPrice": "number", "deliveryTimeWeeks": "number", "bestVendorOfferQuantity": "Orders.VendorOfferItemQuantity", "bestVendorOfferQuantityId": "Orders.VendorOfferItemQuantity.Id", "offerItem": "Orders.CustomerOfferItem", "offerItemId": "Orders.CustomerOfferItem.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({ offerItem: () => Orders.CustomerOfferItem } as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({ bestVendorOfferQuantity: () => Orders.VendorOfferItemQuantity } as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θquantity = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θmargin = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θunitPrice = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θdeliveryTimeWeeks = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θbestVendorOfferQuantity = Signals.proxySignalDeferred<Orders.VendorOfferItemQuantity>(() => (undefined) as any);
    private readonly θbestVendorOfferQuantityId = Signals.proxySignalDeferred<Orders.VendorOfferItemQuantity.Id>(() => (undefined) as any);
    private readonly θofferItem = Signals.proxySignalDeferred<Orders.CustomerOfferItem>(() => (undefined) as any);
    private readonly θofferItemId = Signals.proxySignalDeferred<Orders.CustomerOfferItem.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.CustomerOfferItemQuantity' {
        return 'Orders.CustomerOfferItemQuantity'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.CustomerOfferItemQuantity' {
        return 'Orders.CustomerOfferItemQuantity'
    }

    static get __baseType(): 'Orders.CustomerOfferItemQuantity' {
        return 'Orders.CustomerOfferItemQuantity'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.CustomerOfferItemQuantity' {
        return 'Orders.CustomerOfferItemQuantity'
    }

    get [BoInfoSymbol]() {
        return Orders__CustomerOfferItemQuantity[BoInfoSymbol]
    }

    get quantity(): number {
        return this.θquantity?.()
    }

    set quantity(quantity) {
        this.θquantity.set(coerceDataType(quantity, 'number', false, true))
    }

    get margin(): number {
        return this.θmargin?.()
    }

    set margin(margin) {
        this.θmargin.set(coerceDataType(margin, 'number', false, true))
    }

    get unitPrice(): number {
        return this.θunitPrice?.()
    }

    set unitPrice(unitPrice) {
        this.θunitPrice.set(coerceDataType(unitPrice, 'number', false, true))
    }

    get deliveryTimeWeeks(): number {
        return this.θdeliveryTimeWeeks?.()
    }

    set deliveryTimeWeeks(deliveryTimeWeeks) {
        this.θdeliveryTimeWeeks.set(coerceDataType(deliveryTimeWeeks, 'number', false, true))
    }

    get bestVendorOfferQuantity(): Orders.VendorOfferItemQuantity {
        return this.θbestVendorOfferQuantity?.()
    }

    set bestVendorOfferQuantity(bestVendorOfferQuantity) {
        this.θbestVendorOfferQuantity.set(coerceDataType(bestVendorOfferQuantity, Orders.VendorOfferItemQuantity, false, true))
        if (bestVendorOfferQuantity) {
            this.θbestVendorOfferQuantityId.set(bestVendorOfferQuantity.id)
        } else if (bestVendorOfferQuantity === null && bestVendorOfferQuantity) {
            this.θbestVendorOfferQuantityId.set(null)
        }
    }

    get bestVendorOfferQuantityId(): Orders.VendorOfferItemQuantity.Id {
        return this.θbestVendorOfferQuantityId?.()
    }

    set bestVendorOfferQuantityId(bestVendorOfferQuantityId) {
        if (bestVendorOfferQuantityId === null) this.θbestVendorOfferQuantity.set(null)
        if (this.bestVendorOfferQuantity?.id && bestVendorOfferQuantityId != this.bestVendorOfferQuantity.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θbestVendorOfferQuantityId.set(coerceDataType(bestVendorOfferQuantityId, 'Orders.VendorOfferItemQuantity.Id', false, true))
    }

    get offerItem(): Orders.CustomerOfferItem {
        return this.θofferItem?.()
    }

    set offerItem(offerItem) {
        this.θofferItem.set(coerceDataType(offerItem, Orders.CustomerOfferItem, false, true))
        if (offerItem) {
            this.θofferItemId.set(offerItem.id)
        } else if (offerItem === null && offerItem) {
            this.θofferItemId.set(null)
        }
    }

    get offerItemId(): Orders.CustomerOfferItem.Id {
        return this.θofferItemId?.()
    }

    set offerItemId(offerItemId) {
        if (offerItemId === null) this.θofferItem.set(null)
        if (this.offerItem?.id && offerItemId != this.offerItem.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θofferItemId.set(coerceDataType(offerItemId, 'Orders.CustomerOfferItem.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__CustomerOfferItemQuantity>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__CustomerOfferItemQuantity()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__CustomerOfferItemQuantity>, restrictToClass?: Class<Partial<Orders__CustomerOfferItemQuantity>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('quantity', 'margin', 'unitPrice', 'deliveryTimeWeeks', 'bestVendorOfferQuantity', 'bestVendorOfferQuantityId', 'offerItem', 'offerItemId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__CustomerOfferItemQuantity {
        return equal(this, other)
    }
}

namespace Orders__CustomerOfferItemQuantity { }

export import CustomerOfferItemQuantity = Orders__CustomerOfferItemQuantity
setTimeout(() => {
    jsonProperty(() => Number)(Orders__CustomerOfferItemQuantity.prototype, 'quantity')
    jsonProperty(() => Number)(Orders__CustomerOfferItemQuantity.prototype, 'margin')
    jsonProperty(() => Number)(Orders__CustomerOfferItemQuantity.prototype, 'unitPrice')
    jsonProperty(() => Number)(Orders__CustomerOfferItemQuantity.prototype, 'deliveryTimeWeeks')
    jsonProperty(() => Orders.VendorOfferItemQuantity)(Orders__CustomerOfferItemQuantity.prototype, 'bestVendorOfferQuantity')
    jsonProperty(() => Orders.VendorOfferItemQuantity.Id)(Orders__CustomerOfferItemQuantity.prototype, 'bestVendorOfferQuantityId')
    jsonProperty(() => Orders.CustomerOfferItem)(Orders__CustomerOfferItemQuantity.prototype, 'offerItem')
    jsonProperty(() => Orders.CustomerOfferItem.Id)(Orders__CustomerOfferItemQuantity.prototype, 'offerItemId')
    jsonProperty(() => Date)(Orders__CustomerOfferItemQuantity.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerOfferItemQuantity.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__CustomerOfferItemQuantity.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerOfferItemQuantity.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__CustomerOfferItemQuantity.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerOfferItemQuantity.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__CustomerOfferItemQuantity.prototype, 'versionNumber')
})

export const CustomerOfferItemQuantityθId = Number;

export type CustomerOfferItemQuantityθId = number;

namespace Orders__CustomerOfferItemQuantity {
    export type Id = NominalType<number, 'Orders.CustomerOfferItemQuantity'>

}
